import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Meu cadastro")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Inscreva-se")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.mostrar_cadastro_perfil)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "menu-item destaque",
              to: "/perfil"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "menu-item destaque",
              to: "/cadastro"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
          class: _normalizeClass(["menu-item destaque", _ctx.isLoggedIn ? 'sair' : 'entrar'])
        }, _toDisplayString(_ctx.isLoggedIn ? 'Sair' : 'Entrar'), 3)
      ], 64))
    : _createCommentVNode("", true)
}